import isMatchingCircuit from "../../utils/isMatchingCircuit";
import isMatchingDriver from "../../utils/isMatchingDriver";
/**
 * Return an array of filtered qualifyings given the circuit and driver filters
 * @param qualifying    full array of qualifyings
 * @param raceIdMap     object mapping the race id to the race
 * @param circuitFilter circuit fitler
 * @param driverFilter  driver filter
 * @returns             array of qualifyings that match the circuit and driver filters
 */
export default function getFilteredQualifyings(qualifying, raceIdMap, circuitFilter, driverFilter) {
    return qualifying.filter(q => {
        var _a;
        return (isMatchingCircuit(circuitFilter, (_a = raceIdMap[q.raceId]) === null || _a === void 0 ? void 0 : _a.circuitId) //matching circuit
            && isMatchingDriver(driverFilter, q.driverId) //matching driver
        );
    });
}
